import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import DayJS from 'react-dayjs';

const TypographyStyled = styled(Typography)`
  display: block;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 18px;
  line-height: 18px;
  font-size: 16px;
`

const FloatStyled = styled.div`
  background: white;
  border: 1px solid black;
  border-radius: 15px;
  font-size: 80%;
  z-index: 100;
  position: absolute;
  padding: 2px;
  top: 4px;
  right: 6px;
`;

const Header = ({
  text,
  classes,
  theme,
  score,
  date
}) => {

  return (
    <TypographyStyled variant="title">
      {text}
      { score && (
        <FloatStyled>{score.toFixed(4)}</FloatStyled>
      )}
      { date && (
        <FloatStyled><DayJS format="ddd MMM D, YYYY h:mm a">{date}</DayJS></FloatStyled>
      )}
    </TypographyStyled>
  )
}

Header.propTypes = {
  text: PropTypes.string,
};

Header.defaultProps = {
  
};

export default Header;
